import { Injectable, inject } from '@angular/core';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { AssetService } from './asset.service';

@Injectable({
  providedIn: 'root',
})
export class AssetApprovalLimitService {
  private assetsService = inject(AssetService);

  getApprovedAssetCountForGallery(galleryId: string): Observable<number> {
    return this.assetsService.getAssetsForGalleryObservable(galleryId).pipe(
      map(assets => assets.filter(asset => asset.status === 'approved').length),
      distinctUntilChanged()
    );
  }
}
